import React, { useEffect, useState } from "react";
import AnnouncementsCarousel from "../../components/AnnouncementSlides/Announcements";
import banner1 from "../../assets/Banners/Earth_Station_banner.png";
import banner2 from "../../assets/Banners/Carousell Banner - My Sparrow Click.png";
import banner3 from "../../assets/Banners/Carousell Banner - Only One Liveable PLANet.png";
import banner4 from "../../assets/Banners/Carousell Banner - SaveRed.png";
import TabComponent from "../../components/Tab/Tab";
import Footer from "../../components/footer";
import WhatsNew from "../WhatsNew/WhatsNew";
import EarthStation from "../EarthStation/EarthStation";
import { getAnnouncements, getDownloadCount } from "../../store/Thunk/getAnnouncementsThunk";
import { useDispatch, useSelector } from "react-redux";

import whatsnew_icon from "../../assets/TabIcons/Whats_New_Main.svg";
import whatsnew_icon_active from "../../assets/TabIcons/WhatsNew_active.svg";
import earth_station_icon from "../../assets/TabIcons/Earth_Station_Main.svg";
import earth_station_icon_active from "../../assets/TabIcons/Earth_station_active.svg";
import footprint_icon from "../../assets/TabIcons/Track_your_Footprint_Main.svg";
import footprint_active from "../../assets/TabIcons/footprint_active.svg";
import { setIsShowAnnouncements } from "../../store/Slice/announcementSlice";
import CarbonFootprintDashboard from "../CalculateFootprint/CalculateFootprint";
import Loader from "../../components/Loader/Loader";

const banners = [
  { id: 1, imageUrl: banner1, title: "test1" },
  { id: 2, imageUrl: banner2, title: "test2" },
  { id: 3, imageUrl: banner3, title: "ban2" },
  { id: 4, imageUrl: banner4, title: "ban1" },
  { id: 5, imageUrl: banner1, title: "testban1" },
];

const Tabs = [
  {
    icon: whatsnew_icon,
    active_icon: whatsnew_icon_active,
    label: "What's New",
    ariaLabel: "what's new",
    component: <WhatsNew />,
  },
  {
    icon: earth_station_icon,
    active_icon: earth_station_icon_active,
    label: "#EarthStation",
    ariaLabel: "earth station",
    component: <EarthStation />,
  },
  {
    icon: footprint_icon,
    active_icon: footprint_active,
    label: "Track Your Carbon Footprint",
    ariaLabel: "track carbon footprint",
    component: <CarbonFootprintDashboard />,
  },
];
const LandingScreen = () => {
  const [tabValue, setTabValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { isShowAnnouncements, slidingAnnouncements, count } = useSelector(
    (state) => state.announcement
  );

  const handleTabChange = (event, newValue) => {
    if (newValue === 0) {
      dispatch(setIsShowAnnouncements(true)); //Showing announcements if tab is switched to whats new
    }
    setTabValue(newValue);
  };

  useEffect(() => {
    setLoading(true);
    dispatch(getAnnouncements()).then((res) => {
      if (res.status === "success") {
        setLoading(false);
      }
    });
    dispatch(getDownloadCount())
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <AnnouncementsCarousel
        tabValue={tabValue}
        banners={slidingAnnouncements}
        isShow={isShowAnnouncements}
      />
      <TabComponent
        tabList={Tabs}
        tabValue={tabValue}
        handleTabChange={handleTabChange}
      />
      <Footer />
    </>
  );
};

export default LandingScreen;
